import { AllModules } from '@ag-grid-enterprise/all-modules';
import React, { useEffect, useMemo, useState } from 'react';
import {
	agContainerStyle,
	agDefaultColumnDefination,
	agGridStyle,
	getUploadedTime,
} from '../utils';
import { getDimensionOptionName } from 'Details/utils';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const ApVendorDBPushHistory = ({ list }) => {
	const [rowData, setRowData] = useState([]);
	const containerStyle = useMemo(() => agContainerStyle, []);
	const gridStyle = useMemo(() => agGridStyle, []);
	const defaultColDef = useMemo(() => {
		return agDefaultColumnDefination;
	}, []);

	useEffect(
		() => {
			const rowResult = list.sort((a, b) => b.id - a.id).map(el => {
				return {
					author_name: el.authorName,
					published_time: getUploadedTime(el.published_Time),
					status: getDimensionOptionName(el.status),
				};
			});
			setRowData(rowResult);
		},
		[list]
	);

	const columnDefs = [
		{ field: 'author_name', headerName: 'Pushed by' },
		{ field: 'status', headerName: 'Pipeline Status' },
		{ field: 'published_time', headerName: 'Pushed at' },
	];

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
		pagination: true,
		paginationPageSize: 10,
	};

	return (
		<div style={containerStyle}>
			<AgGridTable gridOptions={gridOptions} gridStyle={gridStyle} />
		</div>
	);
};

export default ApVendorDBPushHistory;
